import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 bg-cream text-navy-dark" data-id="element-1">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-4">
            ¿Es este sistema para ti?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-5">
            El Arca de Efectivo no es una fórmula mágica, es un sistema táctico.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-6">
          {/* Who this IS for */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-gold" data-id="element-7">
            <h3 className="font-heading text-2xl font-bold text-navy mb-6 flex items-center gap-3" data-id="element-8">
              <CheckCircle2 className="text-gold w-8 h-8" data-id="element-9" />
              Para quién SÍ es
            </h3>
            <ul className="space-y-5" data-id="element-10">
              <li className="flex items-start gap-3" data-id="element-11">
                <div className="mt-1 bg-gold/20 p-1 rounded-full shrink-0" data-id="element-12">
                  <div className="w-2 h-2 bg-gold rounded-full" data-id="element-13"></div>
                </div>
                <p className="text-gray-700 leading-relaxed" data-id="element-14">
                  <strong data-id="element-15">Padres de familia</strong> que sienten el peso de la
                  responsabilidad de proteger a los suyos.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-16">
                <div className="mt-1 bg-gold/20 p-1 rounded-full shrink-0" data-id="element-17">
                  <div className="w-2 h-2 bg-gold rounded-full" data-id="element-18"></div>
                </div>
                <p className="text-gray-700 leading-relaxed" data-id="element-19">
                  <strong data-id="element-20">Personas que llegan "con lo justo"</strong> a final de
                  mes y sienten que caminan sobre una cuerda floja.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-21">
                <div className="mt-1 bg-gold/20 p-1 rounded-full shrink-0" data-id="element-22">
                  <div className="w-2 h-2 bg-gold rounded-full" data-id="element-23"></div>
                </div>
                <p className="text-gray-700 leading-relaxed" data-id="element-24">
                  <strong data-id="element-25">Trabajadores que odian la ansiedad</strong> que les
                  produce mirar el saldo del cajero automático.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-26">
                <div className="mt-1 bg-gold/20 p-1 rounded-full shrink-0" data-id="element-27">
                  <div className="w-2 h-2 bg-gold rounded-full" data-id="element-28"></div>
                </div>
                <p className="text-gray-700 leading-relaxed" data-id="element-29">
                  <strong data-id="element-30">Parejas que discuten por dinero</strong> porque nunca
                  hay un colchón para los imprevistos.
                </p>
              </li>
            </ul>
          </div>

          {/* Who this IS NOT for */}
          <div className="bg-cream-dark/20 rounded-2xl p-8 border border-cream-dark" data-id="element-31">
            <h3 className="font-heading text-2xl font-bold text-navy-light mb-6 flex items-center gap-3 opacity-80" data-id="element-32">
              <XCircle className="text-gray-400 w-8 h-8" data-id="element-33" />
              Para quién NO es
            </h3>
            <ul className="space-y-5 opacity-80" data-id="element-34">
              <li className="flex items-start gap-3" data-id="element-35">
                <XCircle className="text-gray-400 w-5 h-5 shrink-0 mt-0.5" data-id="element-36" />
                <p className="text-gray-600 leading-relaxed" data-id="element-37">
                  Personas que buscan inversiones mágicas para hacerse ricas
                  mañana.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-38">
                <XCircle className="text-gray-400 w-5 h-5 shrink-0 mt-0.5" data-id="element-39" />
                <p className="text-gray-600 leading-relaxed" data-id="element-40">
                  Inversores avanzados que ya tienen 6 meses de gastos
                  cubiertos.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-41">
                <XCircle className="text-gray-400 w-5 h-5 shrink-0 mt-0.5" data-id="element-42" />
                <p className="text-gray-600 leading-relaxed" data-id="element-43">
                  Gente que no está dispuesta a mover $5 de su cuenta hoy mismo
                  para empezar.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}